import { render, staticRenderFns } from "./createCompetition.vue?vue&type=template&id=162427bc&scoped=true"
import script from "./createCompetition.vue?vue&type=script&lang=js"
export * from "./createCompetition.vue?vue&type=script&lang=js"
import style0 from "./createCompetition.vue?vue&type=style&index=0&id=162427bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.17_css-loader@6.11.0_webpack@5.100.1__lodash@4.17.21_3wbwi6es6qkhix4tqpj2wcthvi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162427bc",
  null
  
)

export default component.exports